import React from 'react';
import { ChevronRight } from 'lucide-react';
import type { CharacterClass } from '../../../types/progression';

/** Recorrido de la clase elegida: inicial → segunda → tercera. */
export function ClassPath({
  cls
}: {
  cls: CharacterClass;
}) {
  const steps = [{
    name: cls.base,
    how: 'Clase inicial',
    href: undefined
  }, ...(cls.second ? [{
    name: cls.second,
    how: 'Misión de Sebina',
    href: '#sebina'
  }] : []), {
    name: cls.third,
    how: 'Tercera evolución',
    href: '#tercera'
  }];
  return <ol className="flex flex-col gap-2 sm:flex-row sm:items-stretch" aria-label="Recorrido de evolución" data-id="element-776" data-mp="25h7jt11z9ukg">
      {steps.map((s, i) => <li key={s.name} className="flex items-center gap-2 sm:flex-1" data-id="element-777" data-mp="2a8zenns62mge" data-mpi={i}>
          {s.href ? <a href={s.href} className="flex min-h-[56px] flex-1 flex-col justify-center rounded-2xl border border-[#D4AF37]/30 bg-[#0A1628] px-3.5 py-2 transition-colors duration-150 hover:border-[#D4AF37]/60" data-id="element-778" data-mp="2f70zad58qttz">
              <span className="font-cinzel font-bold text-white" data-id="element-779" data-mp="2o8idtr302ngk">{s.name}</span>
              <span className="text-xs text-[#D4AF37]" data-id="element-780" data-mp="vptxcelsuj7r">{s.how}</span>
            </a> : <div className="flex min-h-[56px] flex-1 flex-col justify-center rounded-2xl border border-white/10 bg-[#0A1628] px-3.5 py-2" data-id="element-781" data-mp="rlvtxrpfym8w">
              <span className="font-cinzel font-bold text-white" data-id="element-782" data-mp="hp9an7crk38z">{s.name}</span>
              <span className="text-xs text-gray-400" data-id="element-783" data-mp="hrdp2j8agkni">{s.how}</span>
            </div>}
          {i < steps.length - 1 && <ChevronRight className="hidden h-5 w-5 shrink-0 text-gray-500 sm:block" aria-hidden="true" data-id="element-784" data-mp="1adydbatgwgmu" />}
        </li>)}
    </ol>;
}